import { Divider, GridLegacy as Grid, styled } from '@mui/material';
import { AddCompanyAccountTransactionDialogMode } from './AddCompanyAccountTransactionDialog';
import { useFormatting } from '@/utils/formatting';
import { SMRegular, SMSemiBold } from '@/typography/Typography';

export type AccountUpdateResultProps = {
    mode: AddCompanyAccountTransactionDialogMode;
    amount: number;
    balance: number;
    currency: string;
};

const Row = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(1)
}));

const SectionDivider = styled(Divider)(({ theme }) => ({
    margin: theme.spacing(1, 0)
}));

export const AccountUpdateResult = (props: AccountUpdateResultProps) => {
    const getNewBalance = () => {
        if (props.mode === 'Deposit') {
            return props.balance + props.amount;
        }
        return props.balance - props.amount;
    };

    const { toDecimal } = useFormatting();

    return (
        <>
            <Row container justifyContent="space-between">
                <SMSemiBold>Current balance:</SMSemiBold>
                <SMRegular>
                    {toDecimal(props.balance, 2)} {props.currency}
                </SMRegular>
            </Row>
            <Row container justifyContent="space-between">
                <SMSemiBold>{props.mode}:</SMSemiBold>
                <SMRegular>
                    {toDecimal(props.amount, 2)} {props.currency}
                </SMRegular>
            </Row>

            <SectionDivider />

            <Row container justifyContent="space-between">
                <SMSemiBold>New balance:</SMSemiBold>
                <SMRegular>
                    {toDecimal(getNewBalance(), 2)} {props.currency}
                </SMRegular>
            </Row>
        </>
    );
};
